// data/courses.ts
import { CourseDetailsData } from "./course";

export const courses: CourseDetailsData[] = [
  {
    id: "course-001",
    slug: "ausbildung-preparatory-course",
    title: "Ausbildung Preparatory Course",
    i18nKey: "ausbildung",
    image: "assets/img/course/ausbildung-prep-course-home.png",
    description:
      "Ausbildung in Germany is a paid vocational training program where students study and work at the same time. It's designed for non-academic professions and offers a monthly salary throughout the training. For Bangladeshi students, it's a great opportunity to build a skilled future in Germany and globally. Guideline2Germany provides full preparation and step-by-step support throughout the application process.",
    price: 225000,
    discountedPrice: 156000,
    enrollmentNote:
      "Payment Option: You can pay in 6 installments (every 2 months). First Installment: 26,000 BDT",
    allowInstallment: true,
    category: "General Course",
    hasOutline: true,
    startDate: "2026-08-01",
    registrationDeadline: "2026-07-25",
    outline: [
      {
        title: "Step 1: Eligibility Check",
        description:
          "We assess your age, education, and background to determine your eligibility for Ausbildung programs. You'll also receive guidance in selecting the best field based on your interests and strengths.",
      },
      {
        title: "Step 2: German Language | A1 - B2",
        description:
          "Language mastery is key to success in Ausbildung. This step offers structured German learning from A1 to B2, covering speaking, listening, reading, and writing — all aligned with employer and visa requirements.",
      },

      {
        title: "Step 3: Application Documents Preparation",
        description:
          "We help you prepare a professional CV, cover letter, and other necessary documents in German to match employer expectations and improve acceptance chances.",
      },
      {
        title: "Step 4: Ausbildung Search Strategies",
        description:
          "Learn effective Ausbildung search techniques, how to navigate Ausbildung portals, connect with employers, and apply for Ausbildung positions that match your qualifications.",
      },
      {
        title: "Step 5: Ausbildung Application Submission",
        description:
          "We guide you in submitting applications correctly, ensuring all required documents are complete, properly formatted, and sent to the right Ausbildung providers.",
      },
      {
        title: "Step 6: Ongoing Application Assesment",
        description:
          "Continuous tracking and analysis of submitted applications, identifying areas for improvement, and adjusting strategies for better responses from employers.",
      },
      {
        title: "Step 7: Pre-Interview Preparation",
        description:
          "Learn how to respond to employer emails professionally, schedule interviews, and handle pre-interview formalities to create a strong first impression.",
      },
      {
        title: "Step 8: Ausbildung Interview Preparation",
        description:
          "We provide intensive interview training, mock interviews, and common questions practice to help you confidently present yourself and impress potential employers.",
      },
      {
        title: "Step 9: Post-Interview Communication",
        description:
          "Learn how to follow up professionally after the interview, express continued interest, and negotiate contract details if needed.",
      },
      {
        title: "Step 10: Visa Appointment Application",
        description:
          "Get step-by-step guidance on booking your visa appointment at the German embassy or consulate, ensuring all requirements are met.",
      },
      {
        title: "Step 11: Visa Documents Preparation",
        description:
          "We assist in preparing all required visa documents, including Ausbildung contract, pre-confirmation from Agentur für Arbeit, academic and language documents, ensuring accuracy and completeness.",
      },
      {
        title: "Step 12: Visa Document Submission",
        description:
          "Learn how to submit your visa documents properly to the embassy, following the correct process to avoid delays or rejections.",
      },
      {
        title: "Step 13: Visa Interview Preparation",
        description:
          "Mock visa interviews and training on common visa questions, helping you confidently answer and present your case for approval.",
      },
      {
        title: "Step 14: After Visa Support",
        description:
          "We guide you on travel arrangements, accommodation, registration in Germany, and necessary steps after arrival, ensuring a smooth transition.",
      },
    ],
    courseRegulations:
      "Batch Completion: You must complete your language course with the assigned batch.\nCourse Switching: Switching from this course to another (e.g., from Ausbildung to General Language) is not allowed. Payments made for the Ausbildung course cannot be applied to the German language course.\nPayment Policy: The Ausbildung course has been designed in six steps and course fee can be paid in six instalments; however, these instalments do not correspond to the individual steps of the course.\nPayment Deadlines: All instalment deadlines must be strictly followed. If you miss a  deadline, you will not be allowed to attend the classes until you pay the instalment. You are not allowed to share your personal problems/ family issues with G2G.\nRefund & Withdrawal: Once the course has started, the course fee remains non-refundable, and the full fee is still required if you choose to leave.",
    descriptionBn:
      "Germany-তে Ausbildung একটি paid vocational training program, যেখানে শিক্ষার্থীরা একইসাথে পড়াশোনা ও কাজ করে। এটি মূলত non-academic পেশার জন্য তৈরি এবং পুরো training সময় জুড়ে মাসিক বেতন প্রদান করা হয়। বাংলাদেশি শিক্ষার্থীদের জন্য এটি Germany এবং আন্তর্জাতিকভাবে একটি দক্ষ ও স্থিতিশীল ভবিষ্যৎ গড়ার চমৎকার সুযোগ। Guideline2Germany পুরো application process জুড়ে সম্পূর্ণ প্রস্তুতি ও ধাপে ধাপে সহায়তা প্রদান করে।",

    enrollmentNoteBn:
      "Payment Option: আপনি ৬টি installment-এ (প্রতি ২ মাসে) পরিশোধ করতে পারবেন। প্রথম installment: ২৬,০০০ টাকা",

    courseRegulationsBn:
      "Batch Completion: ভর্তি হওয়া batch-এর সাথেই language course সম্পন্ন করতে হবে।\nCourse Switching: এই course থেকে অন্য কোনো course-এ (যেমন Ausbildung থেকে General Language) পরিবর্তন করা যাবে না। Ausbildung course-এর payment German language course-এ প্রযোজ্য নয়।\nPayment Policy: Ausbildung course ৬টি ধাপে সাজানো এবং fee ৬টি installment-এ পরিশোধ করা যাবে; তবে installment-গুলো course-এর নির্দিষ্ট ধাপের সাথে সম্পর্কিত নয়।\nPayment Deadlines: সব installment নির্ধারিত সময়ের মধ্যে পরিশোধ করতে হবে। deadline মিস করলে payment না হওয়া পর্যন্ত class-এ অংশগ্রহণ করা যাবে না। ব্যক্তিগত বা পারিবারিক কারণ G2G-তে বিবেচনা করা হবে না।\nRefund & Withdrawal: course শুরু হওয়ার পর fee ফেরতযোগ্য নয় এবং course ছেড়ে দিলেও সম্পূর্ণ fee পরিশোধ করতে হবে।",

    outlineBn: [
      {
        title: "ধাপ ১: যোগ্যতা যাচাই",
        description:
          "আপনার বয়স, শিক্ষাগত যোগ্যতা ও পটভূমি মূল্যায়ন করে Ausbildung program-এর জন্য আপনার যোগ্যতা নির্ধারণ করা হয়। পাশাপাশি আপনার আগ্রহ ও দক্ষতার ভিত্তিতে সঠিক field বেছে নিতে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ২: জার্মান ভাষা | A1 - B2",
        description:
          "Ausbildung-এ সফলতার মূল চাবিকাঠি হলো ভাষা দক্ষতা। এই ধাপে A1 থেকে B2 পর্যন্ত structured German শেখানো হয় — speaking, listening, reading ও writing সহ, যা employer ও visa requirement অনুযায়ী সাজানো।",
      },
      {
        title: "ধাপ ৩: Application Document প্রস্তুতি",
        description:
          "Employer-এর প্রত্যাশা পূরণ ও acceptance-এর সম্ভাবনা বাড়াতে German ভাষায় professional CV, cover letter এবং প্রয়োজনীয় document তৈরিতে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ৪: Ausbildung খোঁজার কৌশল",
        description:
          "কার্যকরভাবে Ausbildung খুঁজে পাওয়ার জন্য বিভিন্ন কৌশল শেখানো হয় — যেমন portal ব্যবহার, employer-এর সাথে যোগাযোগ এবং নিজের যোগ্যতা অনুযায়ী apply করা।",
      },
      {
        title: "ধাপ ৫: Application জমা",
        description:
          "সঠিকভাবে application submit করতে step-by-step guidance দেওয়া হয় — সব document সঠিক format-এ এবং উপযুক্ত Ausbildung provider-এর কাছে পাঠানো নিশ্চিত করা হয়।",
      },
      {
        title: "ধাপ ৬: Application মূল্যায়ন ও উন্নয়ন",
        description:
          "জমা দেওয়া application নিয়মিতভাবে পর্যালোচনা করা হয়, উন্নতির ক্ষেত্র চিহ্নিত করা হয় এবং employer-এর কাছ থেকে ভালো response পাওয়ার জন্য কৌশল উন্নত করা হয়।",
      },
      {
        title: "ধাপ ৭: Interview-পূর্ব প্রস্তুতি",
        description:
          "Employer-এর email-এ পেশাদারভাবে সাড়া দেওয়া, interview schedule করা এবং প্রথম impression তৈরি করার জন্য প্রয়োজনীয় প্রস্তুতি শেখানো হয়।",
      },
      {
        title: "ধাপ ৮: Interview প্রস্তুতি",
        description:
          "আত্মবিশ্বাসের সাথে interview দিতে intensive training, mock interview এবং সাধারণ প্রশ্নের অনুশীলন করানো হয়।",
      },
      {
        title: "ধাপ ৯: Interview-পরবর্তী যোগাযোগ",
        description:
          "Interview-এর পর পেশাদারভাবে follow-up করা, আগ্রহ প্রকাশ বজায় রাখা এবং প্রয়োজনে contract নিয়ে আলোচনা করার কৌশল শেখানো হয়।",
      },
      {
        title: "ধাপ ১০: Visa Appointment আবেদন",
        description:
          "German embassy বা consulate-এ visa appointment বুক করার জন্য step-by-step guidance দেওয়া হয় এবং সব requirement পূরণ নিশ্চিত করা হয়।",
      },
      {
        title: "ধাপ ১১: Visa Document প্রস্তুতি",
        description:
          "Ausbildung contract, Agentur für Arbeit-এর pre-approval, শিক্ষাগত ও language certificate সহ সব প্রয়োজনীয় document সঠিকভাবে প্রস্তুত করতে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ১২: Visa Document জমা",
        description:
          "Embassy-তে সঠিকভাবে document জমা দেওয়ার প্রক্রিয়া শেখানো হয় যাতে delay বা rejection এড়ানো যায়।",
      },
      {
        title: "ধাপ ১৩: Visa Interview প্রস্তুতি",
        description:
          "Mock visa interview এবং সাধারণ প্রশ্নের training-এর মাধ্যমে আত্মবিশ্বাসের সাথে interview দেওয়ার প্রস্তুতি করানো হয়।",
      },
      {
        title: "ধাপ ১৪: Visa-পরবর্তী সহায়তা",
        description:
          "Germany-তে যাওয়ার পর accommodation, registration এবং অন্যান্য প্রয়োজনীয় কাজের জন্য সম্পূর্ণ guidance দেওয়া হয়, যাতে একটি smooth transition নিশ্চিত হয়।",
      },
    ],
  },
  {
    id: "course-002",
    slug: "german-language-course",
    title: "German Language Course",
    i18nKey: "german",
    image: "assets/img/course/german-language-course-home.png",
    description:
      "Want to build your future in Germany? Our German language course will help you speak, write, and understand German with confidence — perfect for study, work, or Ausbildung. From beginners to advanced learners, our expert-led lessons and practical exercises make learning fast and effective. Start your journey today and open doors to new opportunities in Germany! Our courses are fully online and live. Active participation in classes, quizzes, and exams is mandatory to ensure real progress and success. Class duration of minimum 90 mins/Class. 2-3 classes/week. Platform: Zoom. Class size - small groups.",
    priceBreakdown: [
      "A1 Level: 18,500 BDT",
      "A2 Level: 19,500 BDT",
      "B1 Level: 23,500 BDT",
      "B2 Level: 25,000 BDT",
    ],
    discountedPriceBreakdown: [
      "A1 Level: 12,500 BDT",
      "A2 Level: 13,500 BDT",
      "B1 Level: 15,500 BDT",
      "B2 Level: 17,500 BDT",
    ],
    levelSchedules: [
      {
        level: "A1",
        startDate: "2026-08-01",
        registrationDeadline: "2026-07-25",
      },
      {
        level: "A2",
        startDate: "2026-08-01",
        registrationDeadline: "2026-07-25",
      },
      {
        level: "B1",
        startDate: "2026-08-15",
        registrationDeadline: "2026-08-10",
      },
      {
        level: "B2",
        startDate: "2026-08-01",
        registrationDeadline: "2026-07-25",
      },
    ],
    allowInstallment: false,
    category: "German Language",
    hasOutline: false,
    descriptionBn:
      "জার্মানিতে আপনার ভবিষ্যৎ গড়তে চান? আমাদের German Language Course আপনাকে আত্মবিশ্বাসের সাথে জার্মান বলতে, লিখতে ও বুঝতে সাহায্য করবে— যা উচ্চশিক্ষা, চাকরি বা Ausbildung-এর জন্য আদর্শ।\n\nকোর্সের বিশেষত্ব:\n- Beginner থেকে Advanced লেভেল পর্যন্ত পূর্ণাঙ্গ গাইডলাইন\n- Expert-led লাইভ ক্লাস ও Practical Exercises\n- দ্রুত ও কার্যকরভাবে ভাষা শেখার আধুনিক মেথড\n\nকোর্সের বিবরণ:\n- মাধ্যম: সম্পূর্ণ Online ও Live (Zoom প্ল্যাটফর্ম)\n- ক্লাসের সময়কাল: ন্যূনতম ৯০ মিনিট\n- ফ্রিকোয়েন্সি: সপ্তাহে ২–৩টি ক্লাস\n- ব্যাচ সাইজ: ছোট গ্রুপ (ব্যক্তিগত মনোযোগ নিশ্চিত করতে)\n\nদ্রষ্টব্য: ক্লাসে উপস্থিতি, কুইজ এবং পরীক্ষায় সক্রিয় অংশগ্রহণ বাধ্যতামূলক। আজই আপনার যাত্রা শুরু করুন এবং জার্মানিতে নতুন সুযোগের দরজা খুলুন।",
  },

  {
    id: "course-007",
    slug: "au-pair-preparatory-course",
    title: "Au Pair Preparatory Course",
    i18nKey: "auPair",
    discontinued: true,
    image: "assets/img/course/au_pair_preparatory_course.png",
    description:
      "Become an au pair in Germany and experience cultural immersion while caring for children. As an au pair, you'll live with a German host family, help with childcare and light housework, receive free room and board, pocket money, and the opportunity to learn German. This program is perfect for young people aged 18-26 who want to gain international experience, improve their German language skills, and build meaningful connections. Guideline2Germany provides complete support from profile creation to visa application and arrival in Germany.",
    price: 45000,
    allowInstallment: false,
    category: "General Course",
    hasOutline: true,
    requirements: [
      "Age: 18-26 years",
      "Not married and no children",
      "German language: At least A2 level",
      "Childcare or teaching experience preferred",
    ],
    outline: [
      {
        title: "Step 1: Eligibility Check",
        description:
          "We assess your age, marital status, language level, and experience to confirm you meet au pair requirements. We also help you understand host family conditions and program expectations.",
      },
      {
        title: "Step 2: Professional Photo Preparation",
        description:
          "Guidance on taking professional photos with neutral background and friendly appearance - including both close-up and full-body shots suitable for your au pair profile.",
      },
      {
        title: "Step 3: Profile Creation & Documents",
        description:
          "We help you create a compelling au pair profile including CV (Lebenslauf), motivation letter, and other supporting documents.",
      },
      {
        title: "Step 4: Host Family Search & Application",
        description:
          "Learn how to use au pair platforms (AuPairWorld, etc.), create an attractive profile, and search for suitable host families. We guide you in highlighting your childcare skills and German learning motivation.",
      },
      {
        title: "Step 5: Message & Cover Letter Writing",
        description:
          "Professional assistance in writing personalized messages and cover letters to host families, explaining why you're interested in their family and what you can offer.",
      },
      {
        title: "Step 6: Video Call & Family Selection",
        description:
          "Preparation for video interviews with host families - what to ask, what to clarify about duties, working hours, pocket money, free time, and contract details.",
      },
      {
        title: "Step 7: Further Communication & Contract",
        description:
          "Learn how to maintain professional communication with your selected host family and understand the official au pair contract, invitation letter, and family documents needed for visa.",
      },
      {
        title: "Step 8: Visa Checklist & Requirements",
        description:
          "Complete overview of German au pair visa requirements including application forms, passport, photos, contract, invitation letter, language certificate, and insurance documents.",
      },
      {
        title: "Step 9: Visa Documents Preparation",
        description:
          "We assist in preparing all visa documents including CV, motivation letter explaining your expectations and plans, birth certificate, host family questionnaire, and travel health insurance.",
      },
      {
        title: "Step 10: Visa Appointment Booking",
        description:
          "Step-by-step guidance on booking your au pair national visa (D-visa) appointment at the German Embassy Dhaka through their online system.",
      },
      {
        title: "Step 11: Visa Interview Preparation",
        description:
          "Mock visa interview practice covering common questions about why you want to be an au pair, your host family, German learning plans, and future goals.",
      },
      {
        title: "Step 12: Visa Document Submission & Interview",
        description:
          "Support for the visa appointment day - what to bring, how to present documents, and tips for a successful visa interview at the embassy.",
      },
      {
        title: "Step 13: After Visa Approval Support",
        description:
          "Post-visa guidance including travel arrangements, arrival coordination with host family, registration in Germany (Einwohnermeldeamt), residence permit application, and enrolling in German language courses.",
      },
    ],
    courseRegulations:
      "Course Commitment: You must complete all preparation steps according to the guidelines and timeline.\nRefund Policy: After the first session, if you decide not to continue the course, the course fee will be fully refunded. After that, the course fee is non-refundable.\nLanguage Requirement: You must demonstrate basic knowledge of German language (A2 minimum).\nImportant Note: Guideline2Germany's responsibility is to prepare you. We do not apply for or process your visa.",
    descriptionBn:
      "Germany-তে au pair হিসেবে কাজ করার মাধ্যমে শিশুদের যত্ন নেওয়ার পাশাপাশি একটি সমৃদ্ধ সাংস্কৃতিক অভিজ্ঞতা অর্জন করুন। Au pair হিসেবে আপনি একটি German host family-র সাথে থাকবেন, childcare ও হালকা গৃহকাজে সহায়তা করবেন এবং বিনামূল্যে থাকা-খাওয়া, pocket money ও German শেখার সুযোগ পাবেন। এটি ১৮–২৬ বছর বয়সী তরুণদের জন্য আদর্শ, যারা international experience নিতে, German ভাষা দক্ষতা বাড়াতে এবং meaningful সম্পর্ক গড়তে চান। Guideline2Germany profile creation থেকে visa application এবং Germany-তে পৌঁছানো পর্যন্ত সম্পূর্ণ সহায়তা প্রদান করে।",

    outlineBn: [
      {
        title: "ধাপ ১: যোগ্যতা যাচাই",
        description:
          "আপনার বয়স, বৈবাহিক অবস্থা, language level ও অভিজ্ঞতা মূল্যায়ন করে au pair program-এর জন্য আপনার যোগ্যতা নিশ্চিত করা হয়। পাশাপাশি host family-এর প্রত্যাশা ও program-এর শর্ত বোঝাতে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ২: Professional Photo প্রস্তুতি",
        description:
          "Neutral background ও স্বাভাবিক, বন্ধুসুলভ appearance সহ professional photo তোলার guidance দেওয়া হয় — profile-এর জন্য উপযুক্ত close-up ও full-body ছবি সহ।",
      },
      {
        title: "ধাপ ৩: Profile তৈরি ও Documents",
        description:
          "CV (Lebenslauf), motivation letter এবং অন্যান্য প্রয়োজনীয় documents সহ একটি আকর্ষণীয় au pair profile তৈরি করতে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ৪: Host Family খোঁজা ও Application",
        description:
          "Au pair platform (যেমন: AuPairWorld) ব্যবহার, শক্তিশালী profile তৈরি এবং উপযুক্ত host family খুঁজে আবেদন করার কৌশল শেখানো হয়। Childcare দক্ষতা ও German শেখার আগ্রহ সঠিকভাবে তুলে ধরতে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ৫: Message ও Cover Letter লেখা",
        description:
          "Host family-র জন্য ব্যক্তিগতকৃত message ও cover letter লিখতে professional সহায়তা — কেন আপনি তাদের family-তে আগ্রহী এবং কীভাবে অবদান রাখতে পারেন তা স্পষ্টভাবে তুলে ধরা হয়।",
      },
      {
        title: "ধাপ ৬: Video Call ও Family Selection",
        description:
          "Host family-র সাথে video interview-এর জন্য প্রস্তুতি — কী প্রশ্ন করবেন, duties, working hours, pocket money, free time ও contract-এর বিষয়গুলো কীভাবে পরিষ্কার করবেন তা শেখানো হয়।",
      },
      {
        title: "ধাপ ৭: যোগাযোগ অব্যাহত রাখা ও Contract",
        description:
          "নির্বাচিত host family-র সাথে পেশাদার যোগাযোগ বজায় রাখা এবং official au pair contract, invitation letter ও visa-এর জন্য প্রয়োজনীয় documents সম্পর্কে ধারণা দেওয়া হয়।",
      },
      {
        title: "ধাপ ৮: Visa Checklist ও Requirements",
        description:
          "Application form, passport, ছবি, contract, invitation letter, language certificate ও insurance সহ German au pair visa-এর সব প্রয়োজনীয়তা বিস্তারিতভাবে বোঝানো হয়।",
      },
      {
        title: "ধাপ ৯: Visa Documents প্রস্তুতি",
        description:
          "CV, motivation letter, birth certificate, host family questionnaire ও travel health insurance সহ সব visa document প্রস্তুত করতে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ১০: Visa Appointment বুকিং",
        description:
          "German Embassy Dhaka-এর online system ব্যবহার করে au pair national visa (D-visa) appointment বুক করার জন্য step-by-step guidance দেওয়া হয়।",
      },
      {
        title: "ধাপ ১১: Visa Interview প্রস্তুতি",
        description:
          "Au pair হওয়ার উদ্দেশ্য, host family, German শেখার পরিকল্পনা ও ভবিষ্যৎ লক্ষ্য নিয়ে সাধারণ প্রশ্নের ওপর mock interview-এর মাধ্যমে প্রস্তুতি দেওয়া হয়।",
      },
      {
        title: "ধাপ ১২: Visa Document জমা ও Interview",
        description:
          "Visa appointment-এর দিন কীভাবে প্রস্তুত থাকবেন, documents কীভাবে উপস্থাপন করবেন এবং সফল interview দেওয়ার জন্য প্রয়োজনীয় tips প্রদান করা হয়।",
      },
      {
        title: "ধাপ ১৩: Visa Approval-পরবর্তী সহায়তা",
        description:
          "Germany-তে যাওয়ার পর travel arrangement, host family-এর সাথে coordination, registration (Einwohnermeldeamt), residence permit এবং German language course-এ ভর্তি সহ সম্পূর্ণ guidance দেওয়া হয়।",
      },
    ],

    courseRegulationsBn:
      "Course Commitment: সব preparation ধাপ নির্ধারিত নির্দেশনা ও সময়সূচি অনুযায়ী সম্পন্ন করতে হবে।\nRefund Policy: প্রথম session-এর পর যদি course চালিয়ে যেতে না চান, course fee সম্পূর্ণ ফেরত দেওয়া হবে। এরপর fee ফেরতযোগ্য নয়।\nLanguage Requirement: ন্যূনতম A2 স্তরের German language দক্ষতা থাকতে হবে।\nImportant Note: Guideline2Germany আপনাকে প্রস্তুত করে; আমরা সরাসরি visa apply বা process করি না।",

    requirementsBn: [
      "বয়স: ১৮–২৬ বছর",
      "অবিবাহিত ও সন্তান নেই",
      "German language: ন্যূনতম A2 স্তর",
      "Childcare বা teaching অভিজ্ঞতা থাকলে অগ্রাধিকার",
    ],
  },
  {
    id: "course-008",
    slug: "fsj-bfd-preparatory-course",
    title: "FSJ/BFD Preparatory Course",
    i18nKey: "fsj",
    image: "assets/img/course/fsj_bfd_preparatory_course.png",
    description:
      "FSJ (Freiwilliges Soziales Jahr) and BFD (Bundesfreiwilligendienst) are voluntary service programs in Germany offering 6-24 month placements in social, educational, or ecological fields. You'll receive pocket money (€300-800/month), free accommodation, health insurance, and German language courses. These programs are perfect for those aged 16-27 (FSJ) or 16+ (BFD) who want to gain practical experience in social work, education, healthcare, or environmental fields while living in Germany. Guideline2Germany provides complete support from eligibility check to visa application and placement start.",
    price: 95000,
    discountedPrice: 65000,
    enrollmentNote:
      "Payment Option: You can pay in 2 installments (every 2 months). First Installment: 32,500 BDT",
    enrollmentNoteBn:
      "Payment Option: আপনি ২টি installment-এ (প্রতি ২ মাসে) পরিশোধ করতে পারবেন। প্রথম installment: ৩২,৫০০ টাকা",
    allowInstallment: true,
    category: "General Course",
    hasOutline: true,
    requirements: [
      "Age: 16-27 for FSJ, 27+ for BFD (no upper limit)",
      "School leaving certificate",
      "German language: B1 is optimal; A2 or good communication skills are sufficient — no certificate mandatory",
      "Interest in social, educational, or ecological work",
      "Full-time commitment (30-40 hours/week)",
    ],
    requirementsBn: [
      "বয়স: FSJ-এর জন্য ১৬-২৭, BFD-এর জন্য ২৭+ (কোনো উর্ধ্বসীমা নেই)",
      "স্কুল ছাড়পত্র (SSC/HSC বা সমমান)",
      "জার্মান ভাষা: B1 সর্বোত্তম; A2 বা ভালো যোগাযোগ দক্ষতা যথেষ্ট — সার্টিফিকেট বাধ্যতামূলক নয়",
      "শিশু পরিচর্যা, শিক্ষা বা সামাজিক কাজে আগ্রহ",
      "পূর্ণকালীন প্রতিশ্রুতি (সপ্তাহে ৩০-৪০ ঘণ্টা)",
    ],
    outline: [
      {
        title: "Step 1: Eligibility Check",
        description:
          "We evaluate your age, education, language skills, and interests to determine your eligibility for FSJ or BFD programs and help you choose the right field (childcare, elderly care, schools, environmental work, etc.).",
      },
      {
        title: "Step 2: Professional Photo & Profile",
        description:
          "Guidance on preparing a professional biometric passport photo and understanding the profile requirements for FSJ/BFD applications.",
      },
      {
        title: "Step 3: CV & Cover Letter Creation",
        description:
          "We help you create a professional German-style CV (1-2 pages) and motivation letter explaining your social motivation, German learning goals, and future career plans in education or social work.",
      },
      {
        title: "Step 4: Finding Placement Organizations",
        description:
          "Learn how to search for FSJ/BFD placements using portals (fsj-stellen.de, fsj-bfd.de, ijgd.de, drk.de, caritas.de, diakonie.de) and filter by field, city, and international applicant requirements.",
      },
      {
        title: "Step 5: Application & Email Writing",
        description:
          "Professional assistance in applying to organizations - uploading CV/cover letter, mentioning Bangladeshi nationality and visa needs, and writing effective emails to placement providers.",
      },
      {
        title: "Step 6: Video Interview Preparation",
        description:
          "Preparation for video interviews with organizations - discussing your motivation, basic German skills, and understanding of the voluntary service program.",
      },
      {
        title: "Step 7: Further Communication & Contract",
        description:
          "Learn how to communicate with placement providers and understand the official FSJ/BFD contract signed by you, provider (Träger), placement site, and BAFzA (for BFD).",
      },
      {
        title: "Step 8: Visa Checklist & Requirements",
        description:
          "Complete overview of German FSJ/BFD visa requirements including passport, biometric photo, application forms, signed contract, language proof, and health insurance.",
      },
      {
        title: "Step 9: Documents Preparation",
        description:
          "We assist in preparing all visa documents including CV, motivation letter, language certificate (A1-B1 or provider confirmation), translated school certificates, and contract details.",
      },
      {
        title: "Step 10: Visa Appointment Booking",
        description:
          "Step-by-step guidance on booking your FSJ/BFD national visa (D-visa) appointment at the German Embassy Dhaka through their online system.",
      },
      {
        title: "Step 11: Visa Interview Preparation",
        description:
          "Mock visa interview practice covering questions about your plans, motivation for voluntary service, German learning commitment, and future goals.",
      },
      {
        title: "Step 12: Visa Submission & Interview",
        description:
          "Support for the visa appointment - document organization, fee payment (~75 EUR in BDT), and tips for presenting your case to the visa officer.",
      },
      {
        title: "Step 13: After Visa Approval & Arrival",
        description:
          "Post-visa guidance including travel arrangements (often arranged by provider), residence registration (Anmeldung), residence permit application, attending intro seminars, and starting German language courses.",
      },
    ],
    courseRegulations:
      "Course Commitment: You must complete all preparation steps and apply early (6-12 months ahead) for best placement opportunities.\nRefund Policy: After the first session, if you decide not to continue the course, the course fee will be fully refunded. After that, the course fee is non-refundable.\nLanguage Requirement: You must demonstrate basic knowledge of German language (A2 minimum).\nImportant Note: Guideline2Germany's responsibility is to prepare you. We do not apply for or process your visa.",
    descriptionBn:
      "FSJ (Freiwilliges Soziales Jahr) এবং BFD (Bundesfreiwilligendienst) হলো Germany-তে ৬–২৪ মাসের voluntary service program, যেখানে social, educational বা ecological ক্ষেত্রে কাজ করার সুযোগ পাওয়া যায়। এই program-এ সাধারণত মাসে ৩০০–৮০০ ইউরো pocket money, বিনামূল্যে থাকা, health insurance এবং German language course-এর সুবিধা থাকে। FSJ সাধারণত ১৬–২৭ বছর বয়সীদের জন্য উপযুক্ত। Guideline2Germany eligibility যাচাই থেকে শুরু করে visa application এবং placement শুরু হওয়া পর্যন্ত সম্পূর্ণ সহায়তা প্রদান করে।",

    outlineBn: [
      {
        title: "ধাপ ১: যোগ্যতা যাচাই",
        description:
          "আপনার বয়স, শিক্ষাগত যোগ্যতা, language skill ও আগ্রহ মূল্যায়ন করে FSJ বা BFD program-এর জন্য আপনার যোগ্যতা নির্ধারণ করা হয়। পাশাপাশি childcare, elderly care, school বা environmental কাজের মতো উপযুক্ত field বেছে নিতে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ২: Professional Photo ও Profile",
        description:
          "FSJ/BFD application-এর জন্য biometric passport size professional photo প্রস্তুত এবং একটি মানসম্মত profile তৈরির জন্য guidance দেওয়া হয়।",
      },
      {
        title: "ধাপ ৩: CV ও Cover Letter তৈরি",
        description:
          "German format অনুযায়ী ১–২ পাতার professional CV (Lebenslauf) এবং motivation letter তৈরি করতে সহায়তা করা হয়, যেখানে আপনার social motivation, German শেখার লক্ষ্য ও ভবিষ্যৎ পরিকল্পনা তুলে ধরা হয়।",
      },
      {
        title: "ধাপ ৪: Placement Organization খোঁজা",
        description:
          "FSJ/BFD placement খুঁজতে বিভিন্ন portal (যেমন: fsj-stellen.de, ijgd.de, drk.de) ব্যবহার শেখানো হয় এবং field, location ও international applicant requirement অনুযায়ী filter করার কৌশল দেখানো হয়।",
      },
      {
        title: "ধাপ ৫: Application ও Email লেখা",
        description:
          "Organization-এ apply করার জন্য professional সহায়তা — CV ও cover letter submit করা, Bangladeshi applicant হিসেবে visa প্রয়োজনীয়তা উল্লেখ করা এবং কার্যকর email লেখা শেখানো হয়।",
      },
      {
        title: "ধাপ ৬: Video Interview প্রস্তুতি",
        description:
          "Placement organization-এর সাথে video interview-এর জন্য প্রস্তুতি — আপনার motivation, basic German দক্ষতা এবং voluntary service program সম্পর্কে ধারণা তুলে ধরতে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ৭: যোগাযোগ ও Contract বোঝা",
        description:
          "Placement provider-এর সাথে পেশাদার যোগাযোগ বজায় রাখা এবং official FSJ/BFD contract (provider, placement site ও সংশ্লিষ্ট কর্তৃপক্ষসহ) সঠিকভাবে বোঝার জন্য guidance দেওয়া হয়।",
      },
      {
        title: "ধাপ ৮: Visa Checklist ও Requirements",
        description:
          "Passport, biometric photo, application form, signed contract, language proof ও health insurance সহ FSJ/BFD visa-এর সব প্রয়োজনীয়তা বিস্তারিতভাবে বোঝানো হয়।",
      },
      {
        title: "ধাপ ৯: Documents প্রস্তুতি",
        description:
          "CV, motivation letter, language certificate (A1–B1 বা provider confirmation), translated academic certificate ও contract details সহ সব visa document প্রস্তুত করতে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ১০: Visa Appointment বুকিং",
        description:
          "German Embassy Dhaka-এর online system ব্যবহার করে FSJ/BFD national visa (D-visa) appointment বুক করার জন্য step-by-step guidance দেওয়া হয়।",
      },
      {
        title: "ধাপ ১১: Visa Interview প্রস্তুতি",
        description:
          "Voluntary service-এ আগ্রহ, German শেখার পরিকল্পনা ও ভবিষ্যৎ লক্ষ্য নিয়ে সাধারণ প্রশ্নের ওপর mock visa interview-এর মাধ্যমে প্রস্তুতি দেওয়া হয়।",
      },
      {
        title: "ধাপ ১২: Visa জমা ও Interview",
        description:
          "Visa appointment-এর দিন কীভাবে প্রস্তুত থাকবেন, documents কীভাবে উপস্থাপন করবেন এবং visa officer-এর কাছে নিজের case সঠিকভাবে তুলে ধরবেন সে বিষয়ে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ১৩: Visa Approval ও Arrival-পরবর্তী সহায়তা",
        description:
          "Germany-তে পৌঁছানোর পর travel arrangement (অনেক ক্ষেত্রে provider দ্বারা), residence registration (Anmeldung), residence permit এবং orientation program-এ অংশগ্রহণসহ সম্পূর্ণ guidance দেওয়া হয়।",
      },
    ],

    courseRegulationsBn:
      "Course Commitment: সেরা placement পাওয়ার জন্য সব preparation ধাপ সম্পন্ন করে কমপক্ষে ৬–১২ মাস আগে আবেদন করা উচিত।\nRefund Policy: প্রথম session-এর পর যদি course চালিয়ে যেতে না চান, course fee সম্পূর্ণ ফেরত দেওয়া হবে। এরপর fee ফেরতযোগ্য নয়।\nLanguage Requirement: ন্যূনতম A2 স্তরের German language দক্ষতা থাকতে হবে।\nImportant Note: Guideline2Germany আপনাকে প্রস্তুত করে; আমরা সরাসরি visa apply বা process করি না।",
  },
  {
    id: "course-004",
    slug: "ausbildung-preparatory-course-without-language",
    title: "Ausbildung Preparatory Course (Without German Language)",
    i18nKey: "ausbildungNoLang",
    image: "assets/img/course/ausbildung-prep-wo-german-lang.png",
    description:
      "Ausbildung in Germany is a paid vocational training program where students study and work at the same time. It's designed for non-academic professions and offers a monthly salary throughout the training. For Bangladeshi students, it's a great opportunity to build a skilled future in Germany and globally. Guideline2Germany provides full preparation and step-by-step support throughout the application process.",
    price: 175000,
    discountedPrice: 125000,
    enrollmentNote:
      "Payment Option: You can pay in 4 installments (every 2 months). First Installment: 31,250 BDT",
    allowInstallment: true,
    category: "General Course",
    hasOutline: true,
    requirements: [
      "Good communication skills",
      "Good German Language knowledge (at least B1 level)",
      "Average-to-good academic background (SSC + HSC / Diploma)",
    ],
    requirementsBn: [
      "ভালো যোগাযোগ দক্ষতা",
      "জার্মান ভাষায় ভালো জ্ঞান (কমপক্ষে B1 স্তর)",
      "মোটামুটি থেকে ভালো একাডেমিক পটভূমি (SSC + HSC / Diploma)",
    ],
    outline: [
      {
        title: "Step 1: Eligibility Check",
        description:
          "We assess your age, education, and background to determine your eligibility for Ausbildung programs. You'll also receive guidance in selecting the best field based on your interests and strengths.",
      },
      {
        title: "Step 2: Application Documents Preparation",
        description:
          "We help you prepare a professional CV, cover letter, and other necessary documents in German to match employer expectations and improve acceptance chances.",
      },
      {
        title: "Step 3: Ausbildung Search Strategies",
        description:
          "Learn effective Ausbildung search techniques, how to navigate Ausbildung portals, connect with employers, and apply for Ausbildung positions that match your qualifications.",
      },
      {
        title: "Step 4: Ausbildung Application Submission",
        description:
          "We guide you in submitting applications correctly, ensuring all required documents are complete, properly formatted, and sent to the right Ausbildung providers.",
      },
      {
        title: "Step 5: Ongoing Application Assesment",
        description:
          "Continuous tracking and analysis of submitted applications, identifying areas for improvement, and adjusting strategies for better responses from employers.",
      },
      {
        title: "Step 6: Pre-Interview Preparation",
        description:
          "Learn how to respond to employer emails professionally, schedule interviews, and handle pre-interview formalities to create a strong first impression.",
      },
      {
        title: "Step 7: Ausbildung Interview Preparation",
        description:
          "We provide intensive interview training, mock interviews, and common questions practice to help you confidently present yourself and impress potential employers.",
      },
      {
        title: "Step 8: Post-Interview Communication",
        description:
          "Learn how to follow up professionally after the interview, express continued interest, and negotiate contract details if needed.",
      },
      {
        title: "Step 9: Visa Appointment Application",
        description:
          "Get step-by-step guidance on booking your visa appointment at the German embassy or consulate, ensuring all requirements are met.",
      },
      {
        title: "Step 10: Visa Documents Preparation",
        description:
          "We assist in preparing all required visa documents, including Ausbildung contract, pre-confirmation from Agentur für Arbeit, academic and language documents, ensuring accuracy and completeness.",
      },
      {
        title: "Step 11: Visa Document Submission",
        description:
          "Learn how to submit your visa documents properly to the embassy, following the correct process to avoid delays or rejections.",
      },
      {
        title: "Step 12: Visa Interview Preparation",
        description:
          "Mock visa interviews and training on common visa questions, helping you confidently answer and present your case for approval.",
      },
      {
        title: "Step 13: After Visa Support",
        description:
          "We guide you on travel arrangements, accommodation, registration in Germany, and necessary steps after arrival, ensuring a smooth transition.",
      },
    ],
    courseRegulations:
      "Batch Completion: You must complete your language course with the assigned batch.\nCourse Switching: Switching from this course to another (e.g., from Ausbildung to General Language) is not allowed. Payments made for the Ausbildung course cannot be applied to the German language course.\nPayment Policy: The Ausbildung course has been designed in six steps and course fee can be paid in six instalments; however, these instalments do not correspond to the individual steps of the course.\nPayment Deadlines: All instalment deadlines must be strictly followed. If you miss a  deadline, you will not be allowed to attend the classes until you pay the instalment. You are not allowed to share your personal problems/ family issues with G2G.\nRefund & Withdrawal: Once the course has started, the course fee remains non-refundable, and the full fee is still required if you choose to leave.",
    descriptionBn:
      "Germany-তে Ausbildung একটি paid vocational training program যেখানে শিক্ষার্থীরা একইসাথে পড়াশোনা ও কাজ করে। এই course-টি তাদের জন্য, যারা ইতিমধ্যে প্রয়োজনীয় German language স্তরে আছেন — language module ছাড়াই সরাসরি Ausbildung preparation শুরু করুন। Guideline2Germany সম্পূর্ণ preparation ও step-by-step support প্রদান করে।",
    outlineBn: [
      {
        title: "ধাপ ১: যোগ্যতা যাচাই",
        description:
          "আমরা আপনার বয়স, শিক্ষা ও পটভূমি মূল্যায়ন করে Ausbildung program-এর জন্য আপনার eligibility নির্ধারণ করি। আপনার আগ্রহ ও দক্ষতার ভিত্তিতে সেরা field বেছে নিতেও guidance দেওয়া হয়।",
      },
      {
        title: "ধাপ ২: Application Documents প্রস্তুতি",
        description:
          "Employer-এর প্রত্যাশা পূরণ এবং acceptance-এর সম্ভাবনা বাড়াতে German ভাষায় professional CV, cover letter ও প্রয়োজনীয় documents তৈরিতে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ৩: Ausbildung খোঁজার কৌশল",
        description:
          "কার্যকর Ausbildung search technique, Ausbildung portal navigate করা, employer-এর সাথে যোগাযোগ এবং আপনার qualification অনুযায়ী position-এ apply করা শিখুন।",
      },
      {
        title: "ধাপ ৪: Ausbildung Application জমা",
        description:
          "সঠিকভাবে application submit করতে guide করা হয় — সব document সম্পূর্ণ, সঠিক format-এ এবং সঠিক provider-এর কাছে পাঠানো নিশ্চিত করা হয়।",
      },
      {
        title: "ধাপ ৫: চলমান Application মূল্যায়ন",
        description:
          "জমা দেওয়া application-এর ক্রমাগত tracking ও বিশ্লেষণ, উন্নতির ক্ষেত্র চিহ্নিতকরণ এবং employer-এর কাছ থেকে ভালো সাড়া পেতে কৌশল পরিমার্জন।",
      },
      {
        title: "ধাপ ৬: Interview-পূর্ব প্রস্তুতি",
        description:
          "Employer-এর email-এ পেশাদারভাবে সাড়া দেওয়া, interview schedule করা এবং প্রথম impression তৈরিতে pre-interview formalities সামলানো শিখুন।",
      },
      {
        title: "ধাপ ৭: Ausbildung Interview প্রস্তুতি",
        description:
          "আত্মবিশ্বাসের সাথে নিজেকে উপস্থাপন করতে intensive interview training, mock interview এবং সাধারণ প্রশ্নের অনুশীলন।",
      },
      {
        title: "ধাপ ৮: Interview-পরবর্তী যোগাযোগ",
        description:
          "Interview-এর পর পেশাদারভাবে follow up করা, আগ্রহ প্রকাশ অব্যাহত রাখা এবং প্রয়োজনে contract-এর বিষয়ে আলোচনা করা শিখুন।",
      },
      {
        title: "ধাপ ৯: Visa Appointment আবেদন",
        description:
          "German embassy বা consulate-এ visa appointment বুক করতে step-by-step guidance — সব requirement পূরণ নিশ্চিত করে।",
      },
      {
        title: "ধাপ ১০: Visa Documents প্রস্তুতি",
        description:
          "Ausbildung contract, Agentur für Arbeit-এর pre-confirmation, শিক্ষাগত ও language documentsসহ সব প্রয়োজনীয় visa documents সঠিকভাবে প্রস্তুত করতে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ১১: Visa Document জমা",
        description:
          "Delay বা rejection এড়াতে embassy-তে সঠিক process অনুসরণ করে visa documents জমা দেওয়া শিখুন।",
      },
      {
        title: "ধাপ ১২: Visa Interview প্রস্তুতি",
        description:
          "Mock visa interview এবং সাধারণ visa প্রশ্নের training — আত্মবিশ্বাসের সাথে উত্তর দিতে এবং approval-এর জন্য নিজের case উপস্থাপন করতে সহায়তা করে।",
      },
      {
        title: "ধাপ ১৩: Visa-পরবর্তী সহায়তা",
        description:
          "Germany-তে travel arrangement, accommodation, registration এবং arrival-পরবর্তী প্রয়োজনীয় পদক্ষেপে guidance — একটি smooth transition নিশ্চিত করতে।",
      },
    ],
    courseRegulationsBn:
      "Batch Completion: ভর্তিকৃত batch-এর সাথেই language course সম্পন্ন করতে হবে।\nCourse Switching: এই course থেকে অন্য course-এ পরিবর্তন করা যাবে না। Ausbildung course-এর payment German language course-এ প্রযোজ্য হবে না।\nPayment Policy: Course fee ছয়টি installment-এ পরিশোধ করা যাবে; তবে এই installment-গুলো course-এর পৃথক step-এর সাথে সম্পর্কিত নয়।\nPayment Deadlines: সব deadline কঠোরভাবে মেনে চলতে হবে। Deadline মিস করলে payment সম্পন্ন না হওয়া পর্যন্ত class-এ অংশগ্রহণ করা যাবে না। ব্যক্তিগত সমস্যা G2G-এর সাথে share করা যাবে না।\nRefund & Withdrawal: Course শুরু হওয়ার পর course fee ফেরতযোগ্য নয়।",
  },

  {
    id: "course-005",
    slug: "ausbildung-searching-visa-processing-course",
    title: "Ausbildung Searching Visa Processing Course",
    i18nKey: "ausbildungSearchVisa",
    image: "assets/img/course/ausbildung-searching-visa-processing-course.png",
    description:
      "Ausbildung Searching Visa – Your Gateway to Germany. The Ausbildung Searching Visa lets you stay in Germany for up to 9 months to find a vocational training opportunity. It's a great chance for Bangladeshi students to connect with employers and start a career without a university degree. Guideline2Germany offers full support with documentation, visa application, and preparation — helping you confidently take the first step toward your Ausbildung journey.",
    price: 95000,
    discountedPrice: 65000,
    enrollmentNote:
      "Payment Option: You can pay in 2 installments (every 2 months). First Installment: 32,500 BDT",
    allowInstallment: true,
    category: "General Course",
    hasOutline: true,
    requirements: [
      "HSC/Diploma Certificate",
      "German Language B1 Level Certificate",
      "Age below 35 years",
      "Financial Proof - Blocked Account / sponsorship letter",
    ],
    requirementsBn: [
      "HSC/Diploma সার্টিফিকেট",
      "জার্মান ভাষা B1 স্তরের সার্টিফিকেট",
      "বয়স ৩৫ বছরের নিচে",
      "আর্থিক প্রমাণ — Blocked Account বা স্পনসরশিপ লেটার",
    ],
    outline: [
      {
        title: "Step 1: Eligibility Check",
        description:
          "We assess your age, education, and background to determine your eligibility for Ausbildung programs. You'll also receive guidance in selecting the best field based on your interests and strengths.",
      },
      {
        title: "Step 2: German Language B1 skill test",
        description:
          "Mastering A1 to B1 German is essential for Ausbildung. This step focuses on structured language learning, improving speaking, listening, reading, and writing skills to meet employer and visa requirements.",
      },
      {
        title: "Step 3: Visa Documents Preparation",
        description:
          "We assist in preparing all required visa documents, including Ausbildung contract, pre-confirmation from Agentur für Arbeit, academic and language documents, ensuring accuracy and completeness.",
      },
      {
        title: "Step 4: Visa Appointment Application",
        description:
          "Get step-by-step guidance on booking your visa appointment at the German embassy or consulate, ensuring all requirements are met.",
      },
      {
        title: "Step 5: Visa Interview Preparation",
        description:
          "Mock visa interviews and training on common visa questions, helping you confidently answer and present your case for approval.",
      },
      {
        title: "Step 6: Visa Document Submission",
        description:
          "Learn how to submit your visa documents properly to the embassy, following the correct process to avoid delays or rejections.",
      },
      {
        title: "Step 7: Financial Proof Preparation",
        description:
          "We assist in preparing the necessary financial proof documents, including blocked account statements or sponsorship letters, to support your visa application.",
      },
      {
        title: "Step 8: After Visa Support",
        description:
          "We guide you on travel arrangements, accommodation, registration in Germany, and necessary steps after arrival, ensuring a smooth transition.",
      },
    ],
    descriptionBn:
      "Ausbildung Searching Visa — Germany-তে আপনার প্রবেশের একটি গুরুত্বপূর্ণ সুযোগ। এই visa-এর মাধ্যমে আপনি সর্বোচ্চ ৯ মাস Germany-তে থেকে vocational training (Ausbildung)-এর সুযোগ খুঁজতে পারবেন। বাংলাদেশি শিক্ষার্থীদের জন্য university degree ছাড়াই employer-দের সাথে সরাসরি যোগাযোগ করে career শুরু করার একটি কার্যকর পথ। Guideline2Germany documentation, visa application ও সম্পূর্ণ preparation-এ step-by-step support দেয় — যাতে আপনি আপনার Ausbildung journey আত্মবিশ্বাসের সাথে শুরু করতে পারেন।",
    outlineBn: [
      {
        title: "ধাপ ১: যোগ্যতা যাচাই",
        description:
          "আমরা আপনার বয়স, শিক্ষা ও পটভূমি মূল্যায়ন করে Ausbildung program-এর জন্য আপনার eligibility নির্ধারণ করি। আপনার আগ্রহ ও দক্ষতার ভিত্তিতে সেরা field বেছে নিতেও guidance দেওয়া হয়।",
      },
      {
        title: "ধাপ ২: German Language B1 দক্ষতা যাচাই",
        description:
          "Ausbildung-এর জন্য কমপক্ষে B1 স্তরের German দক্ষতা প্রয়োজন। এই ধাপে speaking, listening, reading ও writing উন্নত করার মাধ্যমে employer ও visa requirement পূরণে আপনাকে প্রস্তুত করা হয়।",
      },
      {
        title: "ধাপ ৩: Visa Documents প্রস্তুতি",
        description:
          "শিক্ষাগত ও language documentsসহ সব প্রয়োজনীয় visa documents সঠিকভাবে প্রস্তুত করতে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ৪: Visa Appointment আবেদন",
        description:
          "German embassy বা consulate-এ visa appointment বুক করতে step-by-step guidance দেওয়া হয়।",
      },
      {
        title: "ধাপ ৫: Visa Interview প্রস্তুতি",
        description:
          "Mock visa interview এবং সাধারণ visa প্রশ্নের training — আত্মবিশ্বাসের সাথে উত্তর দিতে এবং approval-এর জন্য নিজের case উপস্থাপন করতে সহায়তা করে।",
      },
      {
        title: "ধাপ ৬: Visa Document জমা",
        description:
          "Delay বা rejection এড়াতে embassy-তে সঠিক process অনুসরণ করে visa documents জমা দেওয়া শিখুন।",
      },
      {
        title: "ধাপ ৭: Financial Proof প্রস্তুতি",
        description:
          "Visa application সমর্থনে blocked account statement বা sponsorship letterসহ প্রয়োজনীয় financial proof documents প্রস্তুত করতে সহায়তা করা হয়।",
      },
      {
        title: "ধাপ ৮: Visa-পরবর্তী সহায়তা",
        description:
          "Germany-তে travel arrangement, accommodation, registration এবং arrival-পরবর্তী প্রয়োজনীয় পদক্ষেপে guidance — একটি smooth transition নিশ্চিত করতে।",
      },
    ],
  },

  {
    id: "course-006",
    slug: "combo-ausbildung-searching-and-preparatory-course",
    title: "Combo: Ausbildung Searching and Preparatory Course",
    i18nKey: "comboAusbildung",
    image:
      "assets/img/course/combo-ausbildung-searching-and-preparatory-course.png",
    description:
      "Ausbildung Searching Visa and Preparatory Course – Your Gateway to Germany and start of a successful career. The Ausbildung Searching Visa lets you stay in Germany for up to 9 months to find a vocational training opportunity. It's a great chance for Bangladeshi students to connect with employers and start a career without a university degree. After arraving in Germany we will guide you through the process to get an Ausbildung in Germany. Guideline2Germany offers full support with documentation, visa application, Ausbildung application and Ausbildung Interview — helping you confidently take the steps toward your Ausbildung journey.",
    price: 175000,
    discountedPrice: 125000,
    enrollmentNote:
      "Payment Option: You can pay in 4 installments (every 2 months). First Installment: 31,250 BDT",
    allowInstallment: true,
    category: "General Course",
    hasOutline: true,
    requirements: [
      "HSC/Diploma Certificate",
      "German Language B1 Level Certificate",
      "Age below 35 years",
      "Financial Proof - Blocked Account / sponsorship letter",
    ],
    requirementsBn: [
      "HSC/Diploma সার্টিফিকেট",
      "জার্মান ভাষা B1 স্তরের সার্টিফিকেট",
      "বয়স ৩৫ বছরের নিচে",
      "আর্থিক প্রমাণ — Blocked Account বা স্পনসরশিপ লেটার",
    ],
    outline: [
      {
        title: "Step 1: Eligibility Check",
        description:
          "We assess your age, education, and background to determine your eligibility for Ausbildung programs. You'll also receive guidance in selecting the best field based on your interests and strengths.",
      },
      {
        title: "Step 2: German Language B1 skill test",
        description:
          "Mastering A1 to B1 German is essential for Ausbildung. This step focuses on structured language learning, improving speaking, listening, reading, and writing skills to meet employer and visa requirements.",
      },
      {
        title: "Step 3: Visa Documents Preparation",
        description:
          "We assist in preparing all required visa documents, including Ausbildung contract, pre-confirmation from Agentur für Arbeit, academic and language documents, ensuring accuracy and completeness.",
      },
      {
        title: "Step 4: Visa Appointment Application",
        description:
          "Get step-by-step guidance on booking your visa appointment at the German embassy or consulate, ensuring all requirements are met.",
      },
      {
        title: "Step 5: Visa Interview Preparation",
        description:
          "Mock visa interviews and training on common visa questions, helping you confidently answer and present your case for approval.",
      },
      {
        title: "Step 6: Visa Document Submission",
        description:
          "Learn how to submit your visa documents properly to the embassy, following the correct process to avoid delays or rejections.",
      },
      {
        title: "Step 7: Financial Proof Preparation",
        description:
          "We assist in preparing the necessary financial proof documents, including blocked account statements or sponsorship letters, to support your visa application.",
      },
      {
        title: "Step 8: After Visa Support",
        description:
          "We guide you on travel arrangements, accommodation, registration in Germany, and necessary steps after arrival, ensuring a smooth transition.",
      },

      {
        title: "Step 9: Application Documents Preparation",
        description:
          "We help you prepare a professional CV, cover letter, and other necessary documents in German to match employer expectations and improve acceptance chances.",
      },
      {
        title: "Step 10: Ausbildung Search Strategies",
        description:
          "Learn effective Ausbildung search techniques, how to navigate Ausbildung portals, connect with employers, and apply for Ausbildung positions that match your qualifications.",
      },
      {
        title: "Step 11: Ausbildung Application Submission",
        description:
          "We guide you in submitting applications correctly, ensuring all required documents are complete, properly formatted, and sent to the right Ausbildung providers.",
      },
      {
        title: "Step 12: Ongoing Application Assesment",
        description:
          "Continuous tracking and analysis of submitted applications, identifying areas for improvement, and adjusting strategies for better responses from employers.",
      },
      {
        title: "Step 13: Pre-Interview Preparation",
        description:
          "Learn how to respond to employer emails professionally, schedule interviews, and handle pre-interview formalities to create a strong first impression.",
      },
      {
        title: "Step 14: Ausbildung Interview Preparation",
        description:
          "We provide intensive interview training, mock interviews, and common questions practice to help you confidently present yourself and impress potential employers.",
      },
      {
        title: "Step 15: Post-Interview Communication",
        description:
          "Learn how to follow up professionally after the interview, express continued interest, and negotiate contract details if needed.",
      },
      {
        title: "Step 16: Ausbildung Contract and Start of Your Journey",
        description:
          "Learn how to understand the contract you are getting. You are at the end of your long yet meaningful journey. And as always, when something ends, it marks the beginning of a new one. We will guide you through your first steps.",
      },
    ],
    descriptionBn:
      "Ausbildung Searching Visa ও Preparatory Course — Germany যাওয়া ও সফল career শুরু করার সম্পূর্ণ package। Ausbildung Searching Visa দিয়ে ৯ মাস পর্যন্ত Germany-তে থেকে employer খুঁজুন। Germany-তে পৌঁছানোর পর আমরা আপনাকে Ausbildung পেতে guide করব। Guideline2Germany documentation, visa, Ausbildung application ও Interview-এ সম্পূর্ণ সহায়তা দেয়।",
    outlineBn: [
      {
        title: "ধাপ ১: যোগ্যতা যাচাই",
        description:
          "আমরা আপনার বয়স, শিক্ষা ও পটভূমি মূল্যায়ন করে Ausbildung program-এ eligibility নির্ধারণ করি। আপনার আগ্রহ ও দক্ষতার ভিত্তিতে সেরা field বেছে নিতেও guidance দেওয়া হয়।",
      },
      {
        title: "ধাপ ২: German Language B1 দক্ষতা পরীক্ষা",
        description:
          "Ausbildung-এর জন্য A1 থেকে B1 German আয়ত্ত করা জরুরি। এই ধাপে structured language শেখা, speaking, listening, reading ও writing উন্নত করা হয়।",
      },
      {
        title: "ধাপ ৩: Visa Documents প্রস্তুতি",
        description:
          "Ausbildung contract, Agentur für Arbeit-এর pre-confirmation, শিক্ষাগত ও language documents সহ সব visa documents প্রস্তুত করতে সহায়তা।",
      },
      {
        title: "ধাপ ৪: Visa Appointment আবেদন",
        description:
          "German embassy বা consulate-এ visa appointment বুক করতে step-by-step guidance।",
      },
      {
        title: "ধাপ ৫: Visa Interview প্রস্তুতি",
        description:
          "Mock visa interview ও সাধারণ প্রশ্নের training — আত্মবিশ্বাসের সাথে উত্তর দিতে ও approval-এর জন্য case উপস্থাপন করতে।",
      },
      {
        title: "ধাপ ৬: Visa Document জমা",
        description:
          "Delay বা rejection এড়াতে embassy-তে সঠিক process অনুসরণ করে visa document জমা দেওয়া শিখুন।",
      },
      {
        title: "ধাপ ৭: Financial Proof প্রস্তুতি",
        description:
          "Blocked account statement বা sponsorship letter সহ প্রয়োজনীয় financial proof documents প্রস্তুত করতে সহায়তা।",
      },
      {
        title: "ধাপ ৮: Visa-পরবর্তী সহায়তা",
        description:
          "Germany-তে travel arrangement, accommodation, registration ও arrival-পরবর্তী পদক্ষেপে guidance।",
      },
      {
        title: "ধাপ ৯: Application Documents প্রস্তুতি",
        description:
          "Employer-এর প্রত্যাশা পূরণে German ভাষায় professional CV, cover letter ও প্রয়োজনীয় documents তৈরিতে সহায়তা।",
      },
      {
        title: "ধাপ ১০: Ausbildung খোঁজার কৌশল",
        description:
          "কার্যকর search technique, Ausbildung portal navigate করা, employer-এর সাথে যোগাযোগ ও qualification অনুযায়ী position-এ apply করা শিখুন।",
      },
      {
        title: "ধাপ ১১: Ausbildung Application জমা",
        description:
          "সব document সম্পূর্ণ, সঠিক format-এ ও সঠিক provider-এর কাছে পাঠিয়ে application submit করতে guide করা হয়।",
      },
      {
        title: "ধাপ ১২: চলমান Application মূল্যায়ন",
        description:
          "জমা দেওয়া application-এর tracking ও বিশ্লেষণ, উন্নতির ক্ষেত্র চিহ্নিতকরণ ও কৌশল পরিমার্জন।",
      },
      {
        title: "ধাপ ১৩: Interview-পূর্ব প্রস্তুতি",
        description:
          "Employer-এর email-এ পেশাদারভাবে সাড়া দেওয়া, interview schedule ও pre-interview formalities সামলানো শিখুন।",
      },
      {
        title: "ধাপ ১৪: Ausbildung Interview প্রস্তুতি",
        description:
          "Intensive interview training, mock interview ও সাধারণ প্রশ্নের অনুশীলন — আত্মবিশ্বাসের সাথে নিজেকে উপস্থাপন করতে।",
      },
      {
        title: "ধাপ ১৫: Interview-পরবর্তী যোগাযোগ",
        description:
          "Interview-এর পর পেশাদারভাবে follow up করা ও প্রয়োজনে contract-এর বিষয়ে আলোচনা করা শিখুন।",
      },
      {
        title: "ধাপ ১৬: Ausbildung Contract ও Journey-র শুরু",
        description:
          "যে contract পাচ্ছেন তা বোঝা শিখুন। আপনার দীর্ঘ যাত্রার পরিসমাপ্তি হলো একটি নতুন সূচনা। আমরা আপনার প্রথম পদক্ষেপে guide করব।",
      },
    ],
    enrollmentNoteBn:
      "Payment Option: আপনি ৪টি installment-এ পরিশোধ করতে পারেন। প্রতি installment: ৩১,২৫০ BDT",
  },

  {
    id: "course-003",
    slug: "student-visa-processing-course",
    title: "Student Visa Processing Course",
    i18nKey: "studentVisa",
    image: "assets/img/course/student-visa-processing-course.png",
    description:
      "Our aim is to provide you the proper guideline to make your dream come true. Here we will show you the efficient way of your entire university admission, visa application process as well as guide you through the initial mandatory steps in the land of ideas.",
    price: 75000,
    discountedPrice: 54000,
    enrollmentNote:
      "Payment Option: You can pay in 3 installments (every 2 months). First Installment: 18,000 BDT",
    allowInstallment: true,
    category: "General Course",
    hasOutline: true,
    outline: [
      {
        title: "Step 1: General Information & Profile Evaluation",
        description:
          "We provide comprehensive information about studying in Germany and evaluate your academic background, qualifications, and career goals to determine the best pathway for your student visa application.",
      },
      {
        title: "Step 2: Document Collection & Preparation",
        description:
          "Guidance on gathering and organizing all required documents including academic certificates, transcripts, language certificates, passport copies, and other essential paperwork needed for university and visa applications.",
      },
      {
        title: "Step 3: Course, University & City Selection",
        description:
          "We help you identify suitable study programs, universities, and cities in Germany that align with your academic background, interests, budget, and career aspirations.",
      },
      {
        title: "Step 4: Understanding Admission Requirements",
        description:
          "Detailed explanation of specific admission requirements for your chosen universities and programs, including academic prerequisites, language proficiency levels, and any additional criteria.",
      },
      {
        title: "Step 5: Meeting Admission Requirements",
        description:
          "Support in fulfilling all admission requirements such as obtaining language certificates (TestDaF, IELTS, etc.), credential evaluations, and any supplementary qualifications needed for your application.",
      },
      {
        title: "Step 6: CV & Motivation Letter Creation",
        description:
          "Professional assistance in crafting a compelling German-style CV (Lebenslauf) and a persuasive motivation letter tailored to your chosen program and university standards.",
      },
      {
        title: "Step 7: Application Document Review",
        description:
          "Thorough review and refinement of your CV, motivation letter, and all application documents to ensure they meet university expectations and maximize your chances of acceptance.",
      },
      {
        title: "Step 8: University Application Submission",
        description:
          "Step-by-step guidance on submitting your application through Uni-Assist, university portals, or direct application systems, ensuring all documents are correctly formatted and deadlines are met.",
      },
      {
        title: "Step 9: University Communication Management",
        description:
          "We help you professionally respond to university emails, handle requests for additional documents, and maintain effective communication throughout the admission process.",
      },
      {
        title: "Step 10: Understanding Visa Requirements",
        description:
          "Comprehensive overview of German student visa requirements including blocked account (Sperrkonto), health insurance, financial proof, and other mandatory documents specific to your situation.",
      },
      {
        title: "Step 11: Meeting Visa Requirements",
        description:
          "Assistance in fulfilling all visa prerequisites such as opening a blocked account with the required funds (currently €11,904/year), obtaining health insurance, and gathering financial documents.",
      },
      {
        title: "Step 12: Visa Application Preparation",
        description:
          "Complete preparation of your visa application including filling out forms correctly, organizing documents in the required order, and ensuring all paperwork meets embassy specifications.",
      },
      {
        title: "Step 13: Visa Appointment & Submission",
        description:
          "Guidance on booking your visa appointment at the German embassy or consulate and submitting your application with all required documents properly arranged and verified.",
      },
      {
        title: "Step 14: Visa Interview Preparation",
        description:
          "Intensive training for your visa interview including mock interviews, common question practice, and strategies to confidently present your study plans and financial situation.",
      },
      {
        title: "Step 15: Interview Document Organization",
        description:
          "Final review and reorganization of all documents specifically for the visa interview, ensuring easy access to papers and professional presentation during your appointment.",
      },
      {
        title: "Step 16: Visa Interview",
        description:
          "Support and guidance on the visa interview day, including what to expect, how to conduct yourself professionally, and tips for successfully presenting your case to the visa officer.",
      },
      {
        title: "Step 17: After Visa Approval Support",
        description:
          "Post-visa assistance including travel arrangements, finding accommodation in Germany, university enrollment procedures, city registration (Anmeldung), and settling into student life.",
      },
    ],
    descriptionBn:
      "আপনার স্বপ্নকে বাস্তবে রূপ দিতে আমরা সঠিক guideline দেওয়ার লক্ষ্যে কাজ করি। এখানে আমরা আপনার সম্পূর্ণ university admission ও visa application process-এর সহজ পথ দেখাব এবং 'ধারণার দেশে' প্রথম পদক্ষেপগুলোতে guide করব।",
    outlineBn: [
      {
        title: "ধাপ ১: সাধারণ তথ্য ও Profile মূল্যায়ন",
        description:
          "Germany-তে পড়াশোনা সম্পর্কে বিস্তারিত তথ্য এবং আপনার academic background, qualification ও career লক্ষ্য মূল্যায়ন করে student visa-র সেরা পথ নির্ধারণ।",
      },
      {
        title: "ধাপ ২: Document সংগ্রহ ও প্রস্তুতি",
        description:
          "Academic certificate, transcript, language certificate, passport copy সহ university ও visa application-এর জন্য প্রয়োজনীয় সব documents সংগ্রহ ও সংগঠিত করার guidance।",
      },
      {
        title: "ধাপ ৩: Course, University ও City নির্বাচন",
        description:
          "আপনার academic background, আগ্রহ, বাজেট ও career লক্ষ্য অনুযায়ী Germany-তে উপযুক্ত study program, university ও city চিহ্নিত করতে সহায়তা।",
      },
      {
        title: "ধাপ ৪: Admission Requirements বোঝা",
        description:
          "নির্বাচিত university ও program-এর নির্দিষ্ট admission requirement, language proficiency level ও অন্যান্য criteria সম্পর্কে বিস্তারিত ব্যাখ্যা।",
      },
      {
        title: "ধাপ ৫: Admission Requirements পূরণ",
        description:
          "Language certificate (TestDaF, IELTS ইত্যাদি), credential evaluation ও application-এর জন্য প্রয়োজনীয় supplementary qualification পেতে সহায়তা।",
      },
      {
        title: "ধাপ ৬: CV ও Motivation Letter তৈরি",
        description:
          "German-style CV (Lebenslauf) ও নির্বাচিত program ও university-র মানদণ্ড অনুযায়ী persuasive motivation letter তৈরিতে professional সহায়তা।",
      },
      {
        title: "ধাপ ৭: Application Document পর্যালোচনা",
        description:
          "CV, motivation letter ও সব application document পুঙ্খানুপুঙ্খভাবে পর্যালোচনা ও পরিমার্জন — university-র প্রত্যাশা পূরণ ও acceptance-এর সম্ভাবনা বাড়াতে।",
      },
      {
        title: "ধাপ ৮: University Application জমা",
        description:
          "Uni-Assist, university portal বা direct application system-এর মাধ্যমে application submit করতে step-by-step guidance — সব document সঠিক format-এ ও deadline মেনে।",
      },
      {
        title: "ধাপ ৯: University যোগাযোগ ব্যবস্থাপনা",
        description:
          "University-র email-এ পেশাদারভাবে সাড়া দেওয়া, অতিরিক্ত documents-এর request সামলানো ও admission process জুড়ে কার্যকর যোগাযোগ বজায় রাখতে সহায়তা।",
      },
      {
        title: "ধাপ ১০: Visa Requirements বোঝা",
        description:
          "Blocked account (Sperrkonto), health insurance, financial proof ও আপনার পরিস্থিতি অনুযায়ী mandatory documents সহ German student visa requirements-এর সম্পূর্ণ ধারণা।",
      },
      {
        title: "ধাপ ১১: Visa Requirements পূরণ",
        description:
          "Required funds (বর্তমানে €১১,৯০৪/বছর) সহ blocked account খোলা, health insurance পাওয়া ও financial documents সংগ্রহ করতে সহায়তা।",
      },
      {
        title: "ধাপ ১২: Visa Application প্রস্তুতি",
        description:
          "Form সঠিকভাবে পূরণ, নির্ধারিত ক্রমে documents সাজানো ও সব paperwork embassy-র specification অনুযায়ী নিশ্চিত করে সম্পূর্ণ visa application প্রস্তুতি।",
      },
      {
        title: "ধাপ ১৩: Visa Appointment ও জমা",
        description:
          "German embassy বা consulate-এ visa appointment বুক করা ও সব document সঠিকভাবে সাজিয়ে application জমা দেওয়ার guidance।",
      },
      {
        title: "ধাপ ১৪: Visa Interview প্রস্তুতি",
        description:
          "Study পরিকল্পনা ও আর্থিক অবস্থা আত্মবিশ্বাসের সাথে উপস্থাপন করতে mock interview, সাধারণ প্রশ্নের অনুশীলন ও কৌশল প্রশিক্ষণ।",
      },
      {
        title: "ধাপ ১৫: Interview Document সংগঠন",
        description:
          "Visa interview-এর জন্য সব documents চূড়ান্তভাবে পর্যালোচনা ও পুনর্বিন্যাস — appointment-এ সহজ access ও professional উপস্থাপন নিশ্চিত করতে।",
      },
      {
        title: "ধাপ ১৬: Visa Interview",
        description:
          "Interview-এর দিনে সহায়তা ও guidance — কী আশা করবেন, পেশাদারভাবে কীভাবে আচরণ করবেন ও visa officer-এর কাছে সফলভাবে case উপস্থাপনের tips।",
      },
      {
        title: "ধাপ ১৭: Visa Approval-পরবর্তী সহায়তা",
        description:
          "Travel arrangement, Germany-তে accommodation খোঁজা, university enrollment, city registration (Anmeldung) ও student জীবনে মানিয়ে নেওয়া সহ post-visa সহায়তা।",
      },
    ],
  },
  {
    id: "course-009",
    slug: "german-language-visa-preparatory-course",
    title: "German Language Visa Preparatory Course",
    i18nKey: "germanLangVisa",
    image: "assets/img/course/german_language_visa_preparatory_course.png",
    description:
      "The German Language Course Visa allows you to stay in Germany for 6-12 months to attend an intensive German language course at a registered language school. This visa is perfect for those who want to improve their German language skills for future study, work, or immigration purposes in Germany. You'll attend daily classes, immerse yourself in German culture, and prepare for language exams (Goethe-Zertifikat, TestDaF, telc). Guideline2Germany provides complete support from school selection to visa approval and arrival in Germany.",
    price: 45000,
    allowInstallment: false,
    category: "General Course",
    hasOutline: true,
    requirements: [
      "Age: 18+ years",
      "High school certificate (SSC/HSC or equivalent)",
      "German language: A2 certificate (embassy generally recommends B1, but A2 is accepted)",
      "Financial proof: Blocked account or sponsor (€11,904+ per year)",
      "Health insurance covering Germany",
      "Clear study/career motivation for learning German",
    ],
    requirementsBn: [
      "বয়স: ১৮+ বছর",
      "মাধ্যমিক সার্টিফিকেট (SSC/HSC বা সমমান)",
      "জার্মান ভাষা: A2 সার্টিফিকেট (Embassy সাধারণত B1 recommend করে, তবে A2 গ্রহণযোগ্য)",
      "আর্থিক প্রমাণ: Blocked Account বা স্পনসর (বার্ষিক €১১,৯০৪+)",
      "জার্মানি কভারকারী স্বাস্থ্যবিমা",
      "জার্মান ভাষা শেখার স্পষ্ট পড়াশোনা/ক্যারিয়ার লক্ষ্য",
    ],
    outline: [
      {
        title: "Step 1: Eligibility Check",
        description:
          "We assess your age, educational background, financial capacity, and goals to confirm your eligibility for a German language course visa and help you plan the right course level.",
      },
      {
        title: "Step 2: Finding & Selecting Language School",
        description:
          "Learn how to search for registered German language schools, compare course types (intensive, exam preparation), cities, prices, and schedule. We help you choose schools that meet visa requirements.",
      },
      {
        title: "Step 3: Language School Registration",
        description:
          "Step-by-step guidance on registering with your chosen language school, paying course fees, and obtaining the official admission confirmation (Aufnahmebescheinigung) needed for your visa.",
      },
      {
        title: "Step 4: Blocked Account & Financial Proof",
        description:
          "Complete assistance with opening a blocked account (Sperrkonto) with required funds (currently €11,904+ per year) or preparing sponsorship documents as financial proof for the visa.",
      },
      {
        title: "Step 5: Health Insurance Arrangement",
        description:
          "Guidance on obtaining German health insurance or travel insurance that meets visa requirements and covers your entire stay in Germany from arrival onwards.",
      },
      {
        title: "Step 6: Visa Checklist & Requirements",
        description:
          "Complete overview of German language course visa requirements including passport, photos, application forms, school admission, financial proof, insurance, and accommodation proof.",
      },
      {
        title: "Step 7: Professional Photo",
        description:
          "Guidance on preparing biometric passport photos that meet German visa specifications (recent, neutral background, proper dimensions).",
      },
      {
        title: "Step 8: CV & Cover Letter Preparation",
        description:
          "We help you create a professional CV and motivation letter explaining why you want to learn German, your current language level, study/career goals, and post-course plans.",
      },
      {
        title: "Step 9: Complete Documents Preparation",
        description:
          "We assist in organizing all visa documents including educational certificates, language school admission, blocked account confirmation, insurance certificate, and accommodation proof in the required format.",
      },
      {
        title: "Step 10: Visa Appointment Booking",
        description:
          "Step-by-step guidance on booking your language course visa appointment at the German Embassy Dhaka through their online appointment system.",
      },
      {
        title: "Step 11: Visa Interview Preparation",
        description:
          "Mock visa interview practice covering questions about your motivation to learn German, future plans after the course, financial situation, and ties to Bangladesh.",
      },
      {
        title: "Step 12: Visa Document Submission & Interview",
        description:
          "Support for the visa appointment day - final document check, fee payment (~75 EUR), and tips for a confident presentation to the visa officer.",
      },
      {
        title: "Step 13: After Visa Approval Support",
        description:
          "Post-visa guidance including flight booking, finding accommodation near your language school, city registration (Anmeldung), residence permit application, and settling into your new life in Germany.",
      },
    ],
    courseRegulations:
      "Course Commitment: You must complete all preparation steps according to the guidelines and timeline.\nRefund Policy: After the first session, if you decide not to continue the course, the course fee will be fully refunded. After that, the course fee is non-refundable.\nFinancial Commitment: You must be prepared to show sufficient funds (€11,904+ per year) through a blocked account or strong sponsorship before your visa application.\nImportant Note: Guideline2Germany's responsibility is to prepare you. We do not apply for or process your visa.",
    descriptionBn:
      "German Language Course Visa দিয়ে আপনি ৬-১২ মাস Germany-তে একটি registered language school-এ intensive German language course করতে পারবেন। Future study, কাজ বা immigration-এর জন্য German দক্ষতা উন্নত করতে আগ্রহীদের জন্য এই visa আদর্শ। Daily class-এ অংশ নিন, German সংস্কৃতিতে নিজেকে ডুবিয়ে দিন এবং language exam (Goethe-Zertifikat, TestDaF, telc)-এর জন্য প্রস্তুত হন। Guideline2Germany school selection থেকে visa approval ও Germany-তে arrival পর্যন্ত সম্পূর্ণ support দেয়।",
    outlineBn: [
      {
        title: "ধাপ ১: যোগ্যতা যাচাই",
        description:
          "আপনার বয়স, শিক্ষাগত পটভূমি, আর্থিক সক্ষমতা ও লক্ষ্য মূল্যায়ন করে German language course visa-র eligibility নিশ্চিত করা হয় এবং সঠিক course level পরিকল্পনায় সহায়তা।",
      },
      {
        title: "ধাপ ২: Language School খোঁজা ও নির্বাচন",
        description:
          "Registered German language school খোঁজা, course type (intensive, exam preparation), city, price ও schedule তুলনা করা শিখুন। Visa requirement পূরণকারী school বেছে নিতে সহায়তা।",
      },
      {
        title: "ধাপ ৩: Language School-এ Registration",
        description:
          "নির্বাচিত language school-এ registration, course fee payment ও visa-এর জন্য প্রয়োজনীয় official admission confirmation (Aufnahmebescheinigung) পেতে step-by-step guidance।",
      },
      {
        title: "ধাপ ৪: Blocked Account ও Financial Proof",
        description:
          "Required funds (বর্তমানে €১১,৯০৪+/বছর) সহ blocked account (Sperrkonto) খুলতে বা visa-র financial proof হিসেবে sponsorship documents প্রস্তুত করতে সম্পূর্ণ সহায়তা।",
      },
      {
        title: "ধাপ ৫: Health Insurance ব্যবস্থা",
        description:
          "Germany-তে পৌঁছানোর পর থেকে সম্পূর্ণ থাকার সময় কভার করে এমন visa requirement পূরণকারী German health insurance বা travel insurance পেতে guidance।",
      },
      {
        title: "ধাপ ৬: Visa Checklist ও Requirements",
        description:
          "Passport, ছবি, application form, school admission, financial proof, insurance ও accommodation proof সহ German language course visa requirements-এর সম্পূর্ণ ধারণা।",
      },
      {
        title: "ধাপ ৭: Professional Photo",
        description:
          "German visa specification অনুযায়ী biometric passport photo প্রস্তুতির guidance (সাম্প্রতিক, neutral background, সঠিক মাপ)।",
      },
      {
        title: "ধাপ ৮: CV ও Cover Letter প্রস্তুতি",
        description:
          "German কেন শিখতে চান, বর্তমান language level, study/career লক্ষ্য ও course-পরবর্তী পরিকল্পনা ব্যাখ্যা করে professional CV ও motivation letter তৈরিতে সহায়তা।",
      },
      {
        title: "ধাপ ৯: সম্পূর্ণ Documents প্রস্তুতি",
        description:
          "শিক্ষাগত certificate, language school admission, blocked account confirmation, insurance certificate ও accommodation proof নির্ধারিত format-এ সাজিয়ে সব visa documents প্রস্তুত করতে সহায়তা।",
      },
      {
        title: "ধাপ ১০: Visa Appointment বুকিং",
        description:
          "German Embassy Dhaka-র online appointment system-এর মাধ্যমে language course visa appointment বুক করতে step-by-step guidance।",
      },
      {
        title: "ধাপ ১১: Visa Interview প্রস্তুতি",
        description:
          "German শেখার motivation, course-পরবর্তী পরিকল্পনা, আর্থিক অবস্থা ও Bangladesh-এর সাথে সম্পর্ক নিয়ে প্রশ্নের mock visa interview অনুশীলন।",
      },
      {
        title: "ধাপ ১২: Visa Document জমা ও Interview",
        description:
          "Visa appointment-এর দিনে সহায়তা — চূড়ান্ত document check, fee payment (~৭৫ EUR) ও visa officer-এর কাছে আত্মবিশ্বাসী উপস্থাপনের tips।",
      },
      {
        title: "ধাপ ১৩: Visa Approval-পরবর্তী সহায়তা",
        description:
          "Flight booking, language school-এর কাছে accommodation খোঁজা, city registration (Anmeldung), residence permit application ও Germany-তে নতুন জীবনে মানিয়ে নেওয়া সহ post-visa guidance।",
      },
    ],
    courseRegulationsBn:
      "Course Commitment: সব preparation step নির্দেশিকা ও সময়সূচি অনুযায়ী সম্পন্ন করতে হবে।\nRefund Policy: প্রথম session-এর পর যদি course চালিয়ে না যেতে চান, course fee সম্পূর্ণ ফেরত দেওয়া হবে। এরপর course fee ফেরতযোগ্য নয়।\nFinancial Commitment: Visa application-এর আগে blocked account বা strong sponsorship-এর মাধ্যমে পর্যাপ্ত অর্থ (€১১,৯০৪+/বছর) দেখাতে প্রস্তুত থাকতে হবে।\nImportant Note: Guideline2Germany-র দায়িত্ব আপনাকে প্রস্তুত করা। আমরা visa apply বা process করি না।",
  },
];
